export default {
    name: "refundRulePop",
    props: ["refundRuleObj"],
    computed: {
        refundRuleList() {
            return [this.refundRuleObj]
        }
    }
}
